document.addEventListener('DOMContentLoaded', ()=>{

  new Swiper('.desktop-banner-swiper', {
    slidesPerView: 1,
    loop: true,
    pagination: { el: '.desktop-pagination', clickable: true },
  });

  new Swiper('.mobile-banner-swiper', {
    slidesPerView: 1,
    loop: true,
    pagination: { el: '.mobile-pagination', clickable: true },
  });  

  new Swiper(".items__products.swiper", {
    spaceBetween: 18,
    loop: false,
    slidesPerGroup: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 2.6 },
      343: { slidesPerView: 2.2 },
      768: { slidesPerView: 2.6 },
      1024: { slidesPerView: 5 },
    },
  });
  
    new Swiper('.marquee_interior.swiper-container',{
        spaceBetween:0,
        centeredSlides:!0,
        speed:6000,
        autoplay:{delay:1},
        loop:!0,
        slidesPerView:'auto',
        allowTouchMove:!1,
        disableOnInteraction:!0
    }); 
    
    new Swiper('.loved-by-community-video-wrapper', {
      slidesPerView: 1.4,
      spaceBetween: 15,
      loop: false,
      grabCursor: true,
      breakpoints: { 1024: { slidesPerView: 5, spaceBetween: 30 } },
      navigation: { nextEl: '.loved-community-next', prevEl: '.loved-community-prev' }
    });

    new Swiper(".product_specialty-wrapper-mob", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween:  10
        }
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });    

    document.querySelectorAll('.video-cover').forEach((cover) => {
      cover.addEventListener('click', function () {
        const index = this.getAttribute('data-video-index');
        const videoTemplate = document.querySelector('.popup-video-template[data-video-index="' + index + '"]');
        const popup = document.getElementById('videoPopup');
        const popupContent = popup.querySelector('.video-popup-content');

        if (videoTemplate && popup && popupContent) {
          popupContent.innerHTML = videoTemplate.innerHTML;
          popup.classList.add('active');
          document.body.classList.add('body--video-open');

          const video = popupContent.querySelector('video');
          if (video) {
            video.play();
          }
        }
      });
    });

    document.querySelectorAll('.reviewMoreBtn a').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            var url = this.getAttribute('href');
            if (url) {
                window.open(url, '_blank');
            }
        });
    });    

    document.querySelector('.video-popup-close').addEventListener('click', function () {
      const popup = document.getElementById('videoPopup');
      const popupContent = popup.querySelector('.video-popup-content');
      const video = popupContent.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      popup.classList.remove('active');
      document.body.classList.remove('body--video-open');
      popupContent.innerHTML = '';
    });

    document.getElementById('videoPopup').addEventListener('click', function (e) {
      if (e.target.id === 'videoPopup') {
        document.querySelector('.video-popup-close').click();
      }
    });    

    const imageBannersProducts = document.querySelectorAll('.collection_grid__products.swiper');
    const instances = [];
    const media_mobile = window.matchMedia('(max-width: 749px)');
    media_mobile.addListener(handleSwiper);
    handleSwiper(media_mobile);
    function handleSwiper(e) {
      if (e.matches) {
        imageBannersProducts.forEach((el, i) => {
          if (!instances[i]) { instances[i] = new Swiper(el, { slidesPerView: 'auto', spaceBetween: 15 }); }
        });
      } else {
        instances.forEach(inst => { if (inst) inst.destroy(true, true); });
        instances.length = 0;
      }
    }

    new Swiper('.we-make-beauty-information-slider.swiper', {
      loop: true, spaceBetween: 10, pagination: { el: '.swiper-pagination' },
      speed: 4000, 
      autoplay: { delay: 3000 }
    });

	  new Swiper(".we-make-beauty-logo-slider.swiper", {
      initialSlide: 0, loop: true, freeMode: true, spaceBetween: 0,
      keyboard: { enabled: true },
      pagination: { el: ".swiper-pagination", dynamicBullets: false, clickable: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      breakpoints: {
        1025: { slidesPerView: 6 },
        750: { slidesPerView: 3 },
        0: { slidesPerView: 2.5 }
      }
	  });

    new Swiper(".featured__columns_wp.swiper", {
      slidesPerView: "auto",
      pagination: { el: ".swiper-pagination", clickable: true }
    });   

})


// document.addEventListener('DOMContentLoaded', function () {
//   var swiper = new Swiper('.swiperMagzineLogoelle', {
//     loop: true,
//     freeMode: true,
//     centeredSlides: false,
//     grabCursor: true,
//     spaceBetween: 10,
//     autoplay: { delay: 3000 },
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },

//     breakpoints: {
//       1025: { slidesPerView: 10 },
//       750: { slidesPerView: 4 },
//       0: { slidesPerView: 3 },
//     },
//   });
// });

var divisor = document.getElementById("divisor"),
handle = document.getElementById("handle"),
slider = document.getElementById("slider");

slider.value = 33; 
moveDivisor();

function moveDivisor() {
var sliderValue = slider.value;
handle.style.left = sliderValue + "%";
divisor.style.width = sliderValue + "%";
}

function onTouchStart(event) {
event.preventDefault();
document.addEventListener('touchmove', onTouchMove);
document.addEventListener('touchend', onTouchEnd);
}

function onTouchMove(event) {
var sliderRect = slider.getBoundingClientRect();
var newPosition = (event.touches[0].clientX - sliderRect.left) / sliderRect.width * 100;
newPosition = Math.max(0, Math.min(100, newPosition));
slider.value = newPosition;
moveDivisor();
}

function onTouchEnd(event) {
document.removeEventListener('touchmove', onTouchMove);
document.removeEventListener('touchend', onTouchEnd);
}

function onMouseDown(event) {
event.preventDefault();
document.addEventListener('mousemove', onMouseMove);
document.addEventListener('mouseup', onMouseUp);
onMouseMove(event); 
}

function onMouseMove(event) {
var sliderRect = slider.getBoundingClientRect();
var newPosition = (event.clientX - sliderRect.left) / sliderRect.width * 100;
newPosition = Math.max(0, Math.min(100, newPosition));
slider.value = newPosition;
moveDivisor();
}

function onMouseUp(event) {
document.removeEventListener('mousemove', onMouseMove);
document.removeEventListener('mouseup', onMouseUp);
}

window.onload = function() {
handle.addEventListener('touchstart', onTouchStart);
handle.addEventListener('mousedown', onMouseDown);
};


document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('menu-drawer');
  const closeBtn = document.getElementById('drawerClose');
  const header = document.querySelector('header');

  // Handle multiple toggles
  const toggles = [document.getElementById('drawerToggleDesktop'), document.getElementById('drawerToggleMobile')];

  function openDrawer(toggleBtn) {
    drawer.removeAttribute('hidden');
    toggleBtn.style.display = 'none';
    document.body.classList.add('drawer-open');
    header.classList.add('drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('hidden', 'true');
    toggles.forEach((btn) => {
      if (btn) btn.style.display = 'inline-block';
    });
    document.body.classList.remove('drawer-open');
    header.classList.remove('drawer-open');
  }

  toggles.forEach((toggleBtn) => {
    if (!toggleBtn) return;
    toggleBtn.addEventListener('click', () => openDrawer(toggleBtn));
  });

  // Close with close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (
      !drawer.hasAttribute('hidden') && // drawer is open
      !drawer.contains(e.target) && // click is outside drawer
      !toggles.some((btn) => btn && btn.contains(e.target)) && // not clicking toggle
      e.target !== closeBtn
    ) {
      closeDrawer();
    }
  });
});